import React, { useEffect } from "react";
import { useFormContext, useWatch } from "react-hook-form";

import { AutoFormFieldProps } from "@autoform/react";

import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

// Radix Select forbids an empty-string item value, so optional selects use a
// sentinel to represent "no selection" and dispatch `undefined` on pick.
const CLEAR_VALUE = "__clear__";

export const SelectField: React.FC<AutoFormFieldProps> = ({
  field,
  inputProps,
  error,
  id,
  value,
}) => {
  const { key, ref, ...props } = inputProps;
  const watchedValue = useWatch({
    name: id,
    defaultValue: value ?? field.default,
  });

  return (
    <Select
      {...props}
      onValueChange={(next) => {
        const syntheticEvent = {
          target: {
            value: next === CLEAR_VALUE ? null : next,
            name: id,
          },
        } as React.ChangeEvent<HTMLInputElement>;
        props.onChange(syntheticEvent);
      }}
      value={watchedValue ?? CLEAR_VALUE}
    >
      <SelectTrigger id={id} className={error ? "border-destructive" : ""}>
        <SelectValue placeholder="Select an option" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem
          value={CLEAR_VALUE}
          className="text-muted-foreground font-light hover:text-muted-foreground"
        >
          Select an option
        </SelectItem>
        {(field.options || []).map(([key, label]) => (
          <SelectItem key={key} value={key}>
            {label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
